import React from 'react'
import gql from 'graphql-tag'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import DefaultProductStatus from '../../DefaultProductStatus'

const DigitalStylingProduct = ({product}) => {
  if (product.state === 'delivered') {
    return (
      <DeliveredUrl
        product={product}
        getDeliveredUrl={({assets}) => {
          const report = assets.edges.find(e => e.node.scope === 'output')
          return report && report.node.url
        }}
      />
    )
  }

  return (
    <DefaultProductStatus product={product} />
  )
}

DigitalStylingProduct.fragment = gql`
  fragment DigitalStylingProduct on DigitalStylingProduct {
    booking {id, startsAt, endsAt, resourceName}
    assets {
      edges {
        node {
          id
          state
          ...on UrlAsset {url, scope}
        }
      }
    }
  }
`

export default DigitalStylingProduct
